export const TOGGLE_DESCENDANTS = 'event-showDescendants';
